// mutations
export const SET_PORTORG = 'SET_PORTORG'; // 登录用户身份
export const SET_USERINFO = 'SET_USERINFO'; // 登录用户信息
export const SET_ADMINIDENTITY = 'SET_ADMINIDENTITY'; // 用户身份信息
export const SET_ADMINIDENTITYINDEX = 'SET_ADMINIDENTITYINDEX'; // 用户身份信息下标
export const SET_THEUSERIDENTITY = 'SET_THEUSERIDENTITY'; // 用户身份标识
export const SET_STATERESET = 'SET_STATERESET'; // 重置所有state
export const SET_CURRENTROUTEINFO = 'SET_CURRENTROUTEINFO'; // 路由列表
export const SET_ROUTELIST = 'SET_ROUTELIST'; // 路由列表
export const SET_LEFTNAVLIST = 'SET_LEFTNAVLIST'; // 左侧导航菜单
export const SET_UPLOADTOKEN = 'SET_UPLOADTOKEN'; // 上传token
export const SET_UPLOADURL = 'SET_UPLOADURL'; // 上传url
export const SET_CACHEROUTE = 'SET_CACHEROUTE'; // 缓存组件
export const PUSH_CACHEROUTE = 'PUSH_CACHEROUTE'; // 添加缓存组件
export const DELETE_CACHEROUTE = 'DELETE_CACHEROUTE'; // 删除缓存组件

export const SET_TABSLIST = 'SET_TABSLIST'; // 更新tabs
export const SET_SCHOOLLIST = 'SET_SCHOOLLIST'; // 更新schoolList
export const SET_SCHOOLINDEX = 'SET_SCHOOLINDEX'; // 更新schoolIndex
export const SET_ORGBYOPE = 'SET_ORGBYOPE'; // 设置 运营端 查询 机构列表
export const SET_SCHBYOPE = 'SET_SCHBYOPE'; // 设置 运营端 查询 学校列表
export const SET_COLUMNS_MODULE = 'SET_COLUMNS_MODULE'; // 设置 表头
export const SET_LEFTSWITCH = 'SET_LEFTSWITCH'; // 设置 导航收起
export const SET_BROWSINGHISTORYLIST = 'SET_BROWSINGHISTORYLIST'; // 设置 浏览记录
export const CLOSE_BROWSINGHISTORYLIST = 'CLOSE_BROWSINGHISTORYLIST'; // 关闭 删除 浏览记录
export const SET_AUTH_MAP = 'SET_AUTH_MAP'; // 设置 权限集合
export const SET_KACI = 'SET_KACI'; // 设置内容区域缓存实例
export const SET_IFROUTERALIVE = 'SET_IFROUTERALIVE'; // 设置内容区域刷新

export const SET_SELECTSCHOOL = 'SET_SELECTSCHOOL'; // 设置选择学校
